import { primaryTabStyles } from './PrimaryTab.styles';
import { secondaryTabStyles } from './SecondaryTab.styles';
export const tabVariantStyles = {
    primary: primaryTabStyles,
    secondary: secondaryTabStyles,
};
